import React from "react";
import { Link } from "react-router-dom";
import { API_ROOT, apiJson } from "../shared";
import { useAuth } from "../auth";
import { trackNewsletterSubscribe } from "../analytics";

function FooterLink({ children, to, href }) {
  if (to) {
    return (
      <Link className="jh-footer-link" to={to}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a
        className="jh-footer-link"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    );
  }

  return (
    <button className="jh-footer-link" type="button">
      {children}
    </button>
  );
}

export default function SiteFooter() {
  const { token } = useAuth() || {};
  const [newsletterEmail, setNewsletterEmail] = React.useState("");
  const [newsletterStatus, setNewsletterStatus] = React.useState("idle");
  const [newsletterError, setNewsletterError] = React.useState("");

  const submitNewsletter = async () => {
    setNewsletterError("");
    if (!API_ROOT) {
      setNewsletterError("Newsletter is not configured.");
      return;
    }
    const email = String(newsletterEmail || "").trim();
    if (!email) {
      setNewsletterError("Enter your email.");
      return;
    }

    try {
      setNewsletterStatus("sending");
      const resp = await apiJson(API_ROOT, "/newsletter/subscribe", {
        method: "POST",
        body: JSON.stringify({ email, source: "footer" }),
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
        },
      });
      try {
        const GA4_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID || "";
        const alreadyTracked = (() => {
          try {
            return sessionStorage.getItem("ga4:newsletter_sign_up") === "1";
          } catch {
            return false;
          }
        })();

        const alreadySubscribed = !!resp?.alreadySubscribed;

        if (GA4_ID && !alreadyTracked && !alreadySubscribed) {
          trackNewsletterSubscribe({ measurementId: GA4_ID, source: "footer" });
          try {
            sessionStorage.setItem("ga4:newsletter_sign_up", "1");
          } catch {}
        }
      } catch {}
      setNewsletterStatus("sent");
      setNewsletterEmail("");
    } catch (e) {
      setNewsletterStatus("idle");
      setNewsletterError(String(e.message || e));
    }
  };

  return (
    <footer className="jh-footer">
      <div className="jh-footer-inner">
        <div className="jh-footer-grid">
          <div className="jh-footer-col jh-footer-col--signup">
            <div className="jh-footer-title">Sign up for our newsletter</div>
            <div className="jh-footer-text">
              Sign up for exclusive drops, discounts, and get FREE US shipping
              on your first order, unsubscribe anytime.
            </div>
            <div className="jh-footer-form">
              <input
                className="jh-footer-input"
                placeholder="Email address"
                aria-label="Email address"
                value={newsletterEmail}
                onChange={(e) => setNewsletterEmail(e.target.value)}
              />
              <button
                className="jh-btn"
                type="button"
                onClick={submitNewsletter}
                disabled={newsletterStatus === "sending"}
              >
                {newsletterStatus === "sending" ? "Signing up..." : "Sign up"}
              </button>
            </div>
            {newsletterError ? (
              <div
                className="jh-footer-text"
                style={{ marginTop: 10, color: "#b91c1c" }}
              >
                {newsletterError}
              </div>
            ) : null}
            {newsletterStatus === "sent" ? (
              <div className="jh-footer-text" style={{ marginTop: 10 }}>
                You’re subscribed.
              </div>
            ) : null}
          </div>

          <div className="jh-footer-col jh-footer-col--help">
            <div className="jh-footer-title">Help</div>
            <div className="jh-footer-links">
              <FooterLink to="/shipping">Shipping</FooterLink>
              {/* <FooterLink>Returns</FooterLink> */}
              <FooterLink to="/faq">FAQs</FooterLink>
              <FooterLink to="/privacy">Privacy</FooterLink>
              {/* <FooterLink>Wholesale</FooterLink> */}
              <FooterLink to="/accessibility">Accessibility</FooterLink>
              {/* <FooterLink>Site Map</FooterLink> */}
              <FooterLink to="/contact">Contact Us</FooterLink>
            </div>
            <div className="jh-footer-text" style={{ marginTop: 35 }}>
              support@ridleyjewelry.com
              {/* • 732-111-1111 */}
            </div>
            {/* <div className="jh-footer-text">
              7am - 4pm PST • Monday - Friday
            </div> */}
          </div>

          <div className="jh-footer-col jh-footer-col--social">
            <div className="jh-footer-title">Social</div>
            <div className="jh-footer-links">
              <FooterLink href="https://www.facebook.com/profile.php?id=61591213317898">
                Facebook
              </FooterLink>
              <FooterLink href="https://www.youtube.com/@ridleyjewelry">
                YouTube
              </FooterLink>
              <FooterLink href="https://www.instagram.com/ridleyjewelry/">
                Instagram
              </FooterLink>
              <FooterLink href="https://www.tiktok.com/@ridleyjewelry">
                TikTok
              </FooterLink>
              <FooterLink href="https://x.com/ridleyjewelryco">
                Twitter
              </FooterLink>
            </div>
          </div>
        </div>

        <div className="jh-footer-bottom">
          <div className="jh-footer-small">
            © {new Date().getFullYear()} Ridley Jewelry
          </div>
        </div>
      </div>
    </footer>
  );
}
